import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { completeOnboarding, createSetor, inviteMemberWithSectors, validateToken } from './actions';
import { Setor, OnboardingState, Membro } from '../types';

const initialState: OnboardingState = {
  token: null,
  data: null,
  isLoading: false,
  completeResult: null,
  createSetoresLoading: false,
  inviteMembrosLoading: false,
  errorMessage: null,
  setores: [
    {
      id: 'geral',
      nome: 'Geral',
      descricao: 'Setor padrão para todos os membros',
      isPadrao: true,
    },
  ],
  membros: [],
};

const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    setSetores(state, action: PayloadAction<Setor[]>) {
      state.setores = action.payload;
    },
    addSetor(state, action: PayloadAction<Setor>) {
      state.setores.push(action.payload);
    },
    updateSetor(state, action: PayloadAction<Setor>) {
      const idx = state.setores.findIndex((s) => s.id === action.payload.id);
      if (idx >= 0) state.setores[idx] = action.payload;
    },
    removeSetor(state, action: PayloadAction<string>) {
      state.setores = state.setores.filter((s) => s.id !== action.payload);
    },
    resetOnboarding() {
      return initialState;
    },
    setMembrosPayload(state, action: PayloadAction<Membro[]>) {
      state.membros = action.payload;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setOnboardingData(state, action: PayloadAction<any>) {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(validateToken.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(validateToken.fulfilled, (state, action) => {
        state.isLoading = false;
        state.token = action.meta.arg.token;
        state.data = action.payload;
      })
      .addCase(validateToken.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = (action.payload as string) || action.error.message || null;
      })
      .addCase(completeOnboarding.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(completeOnboarding.fulfilled, (state, action) => {
        state.isLoading = false;
        state.completeResult = action.payload;
      })
      .addCase(completeOnboarding.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = (action.payload as string) || action.error.message || null;
      })
      .addCase(createSetor.pending, (state) => {
        state.createSetoresLoading = true;
        state.errorMessage = null;
      })
      .addCase(createSetor.fulfilled, (state) => {
        state.createSetoresLoading = false;
      })
      .addCase(createSetor.rejected, (state, action) => {
        state.createSetoresLoading = false;
        state.errorMessage = (action.payload as string) || action.error.message || null;
      })
      .addCase(inviteMemberWithSectors.pending, (state) => {
        state.inviteMembrosLoading = true;
        state.errorMessage = null;
      })
      .addCase(inviteMemberWithSectors.fulfilled, (state) => {
        state.inviteMembrosLoading = false;
      })
      .addCase(inviteMemberWithSectors.rejected, (state, action) => {
        state.inviteMembrosLoading = false;
        state.errorMessage = (action.payload as string) || action.error.message || null;
      });
  },
});

export default onboardingSlice.reducer;
export const {
  setSetores,
  addSetor,
  updateSetor,
  removeSetor,
  setMembrosPayload,
  setOnboardingData,
} = onboardingSlice.actions;
